export default __webpack_public_path__ + "static/media/oh-snap.9a912ab8.gif";